import React, {Fragment} from 'react';
import moment from 'moment';
import defaultUser from '../../assets/default-user.png';

const ListComment = ({comments}) => {
  return (
    <Fragment>
      {comments.length ? comments.map(e => (
        <div className="row mx-0">
          <div className="col-lg-4 col-md-3 col-sm-12 col-12">
            <table className="table-borderless">
              <tr>
                <td>
                  <img src={defaultUser} alt="nama" style={{width: '60px', height: '60px', borderRadius: '50%', obejctFit: 'cover', marginRight: '10px'}}/>
                </td>
                <td>
                  <p className="mb-2" style={{fontSize: '13px', fontWeight: '600'}}>{e.name}</p>
                  <p className="text-muted small mb-0">DKI Jakarta, Indonesia</p>
                </td>
              </tr>
            </table>
          </div>
          <div className="col-lg-8 col-md-9 col-sm-12 col-12">
            <div style={{borderLeft: '1px solid rgba(0,0,0,0.12)', padding: '5px 20px'}}>
              <p style={{fontSize: '14px', fontWeight: '600'}}>{e.comment}</p>
              <p className="text-muted small mb-0">Diposting tanggal {moment(e.createdAt).format('D MMM YYYY')} {moment(e.createdAt).format('hh:mm')}</p>
            </div>
          </div>
        </div>
        )
      ) : null}
    </Fragment>
  )
}

export default ListComment